import React, { useContext, useEffect, useState } from "react";
import Input from "../../shared/components/Input";
import {
	VALIDATOR_VALIDATED,
	VALIDATOR_AUTOCOMPLETE,
	VALIDATOR_NUMBER_ONLY,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "../../context/AuthContext";
import { useSnackbar } from "notistack";
import axios from "axios";
import { baseUrl } from "../../baseUrl";

const ReceiptSearch = (props) => {
	const [isLoading, setIsLoading] = useState(false);
	const auth = useContext(AuthContext);
	const { enqueueSnackbar } = useSnackbar();

	const [formState, inputHandler] = useForm(
		{
			name: {
				value: "",
				isValid: true,
			},
			doctorName: {
				value: "",
				isValid: true,
			},
			receiptNumber: {
				value: "",
				isValid: true,
			},
			submissionDate1: {
				value: "",
				isValid: true,
			},
			submissionDate2: {
				value: "",
				isvalid: true,
			},
			price1: {
				value: "",
				isvalid: true,
			},
			price2: {
				value: "",
				isvalid: true,
			},
			isPaid: {
				value: "",
				isvalid: true,
			},
		},
		true
	);
	const ReceiptSearchHandler = async (event) => {
		event.preventDefault();
		await searchReceipts();
	};

	const [doctorNames, setDoctorNames] = useState([]);
	const getDoctorsNames = async () => {
		try {
			const response = await fetch(
				baseUrl + `/api/v1/laboratorys/get-doctors`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						authorization: auth.token,
					},
					body: JSON.stringify({
						onlyName: true,
						page: 1,
					}),
				}
			);
			if (response.ok) {
				const responseData = await response.json();
				setDoctorNames(
					responseData.data.result.map((item) => {
						return { name: item.name, id: item.id };
					})
				);
			} else {
				throw new Error(response.message);
			}
		} catch (err) {
			err &&
				err.data.map((error) =>
					enqueueSnackbar(error, { variant: "error" })
				);
		}
	};

	const searchReceipts = async () => {
		setIsLoading(true);

		axios
			.post(
				`/api/v1/laboratorys/search-receipts`,
				{
					isPayed: formState.inputs.isPaid.value === "پرداخت شده",
					page: props.page,
					rowCount: props.rowCount,
					...(formState.inputs.receiptNumber.value && {
						receiptCode: formState.inputs.receiptNumber.value,
					}),
					...(formState.inputs.name.value && {
						name: formState.inputs.name.value,
					}),
					...(formState.inputs.doctorName.value && {
						doctorLabId: formState.inputs.doctorName.value.id,
					}),
					...(formState.inputs.receiptNumber.value && {
						receiptCode: formState.inputs.receiptNumber.value,
					}),
					...(formState.inputs.submissionDate1.value && {
						submissionDateInterval1: new Date(
							formState.inputs.submissionDate1.value
						).getTime(),
					}),
					...(formState.inputs.submissionDate2.value && {
						submissionDateInterval2: new Date(
							formState.inputs.submissionDate2.value
						).getTime(),
					}),
					...(formState.inputs.price1.value && {
						totalPriceInterval1: formState.inputs.price1.value,
					}),
					...(formState.inputs.price2.value && {
						totalPriceInterval2: formState.inputs.price2.value,
					}),
				},
				{ headers: { authorization: auth.token } }
			)
			.then((response) => {
				props.updateReceiptData(
					response.data.data.result,
					response.data.data.pages
				);
			})
			.catch((err) => {
				err.data &&
					err.data.map((error) => {
						enqueueSnackbar(error, { variant: "error" });
					});
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	useEffect(() => {
		getDoctorsNames();
	}, []);

	useEffect(() => {
		searchReceipts();
	}, [props.page]);

	const PAIDSTATUS = ["پرداخت شده", "پرداخت نشده"];

	return (
		<React.Fragment>
			<Backdrop
				sx={{
					color: "#fff",
					zIndex: (theme) => theme.zIndex.drawer + 1,
				}}
				open={isLoading}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
			<form onSubmit={ReceiptSearchHandler}>
				<Grid container spacing={2}>
					<Grid md={3} xs={12}>
						<Input
							id="name"
							element="input"
							label="به نام"
							validators={[VALIDATOR_VALIDATED()]}
							errorText="لطفا به نام را وارد کنید."
							onInput={inputHandler}
							inputValid={true}
							size="small"
						/>
					</Grid>
					<Grid md={3} xs={12}>
						<Input
							id="doctorName"
							element="autoComplete"
							label="نام پزشک"
							validators={[VALIDATOR_AUTOCOMPLETE()]}
							errorText="لطفا نام دکتر را انتخاب کنید."
							onInput={inputHandler}
							options={doctorNames}
							inputValid={true}
							size="small"
							getOptionLabel={(doctor) => doctor.name}
						/>
					</Grid>
					<Grid md={3} xs={12}>
						<Input
							id="receiptNumber"
							element="input"
							label="شماره فاکتور"
							validators={[VALIDATOR_VALIDATED()]}
							errorText="لطفا شماره فاکتور را وارد نمایید."
							onInput={inputHandler}
							inputValid={true}
							size="small"
						/>
					</Grid>
					<Grid md={3} xs={12}>
						<Input
							id="isPaid"
							element="autoComplete"
							label="وضعیت پرداخت"
							validators={[VALIDATOR_AUTOCOMPLETE()]}
							errorText="لطفا وضعیت پرداخت را انتخاب کنید."
							onInput={inputHandler}
							options={PAIDSTATUS}
							inputValid={true}
							size="small"
							getOptionLabel={(pay) => pay}
						/>
					</Grid>
					<Grid md={6} xs={12}>
						<Grid md={12}>
							<Typography
								variant="caption"
								display="block"
								gutterBottom
								sx={{ mt: 1 }}
							>
								بازه صدور فاکتور
							</Typography>
						</Grid>
						<Grid md={12}>
							<Input
								id="submissionDate1"
								element="datePick"
								validators={[VALIDATOR_VALIDATED()]}
								errorText="ورودی نامعتبر"
								onInput={inputHandler}
								inputValid={true}
								disabled={false}
								label="شروع"
								disableFuture={true}
								size="small"
								variant="standard"
							/>
						</Grid>
						<Grid md={12}>
							<Input
								id="submissionDate2"
								element="datePick"
								validators={[VALIDATOR_VALIDATED()]}
								errorText="ورودی نامعتبر"
								onInput={inputHandler}
								inputValid={true}
								disabled={false}
								label="پایان"
								disableFuture={true}
								size="small"
								variant="standard"
							/>
						</Grid>
					</Grid>
					<Grid md={6} xs={12}>
						<Grid md={12}>
							<Typography
								variant="caption"
								display="block"
								gutterBottom
								sx={{ mt: 1 }}
							>
								بازه قیمتی فاکتور
							</Typography>
						</Grid>
						<Grid md={12}>
							<Input
								id="price1"
								element="number_only"
								label="شروع"
								validators={[
									VALIDATOR_VALIDATED(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								onInput={inputHandler}
								errorText="لطفا فقط عدد وارد کنید."
								inputValid={true}
								size="small"
								variant="standard"
								needsThousandSeparator
							/>
						</Grid>
						<Grid md={12}>
							<Input
								id="price2"
								element="number_only"
								label="پایان"
								errorText="لطفا فقط عدد وارد کنید."
								validators={[
									VALIDATOR_VALIDATED(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								onInput={inputHandler}
								inputValid={true}
								size="small"
								variant="standard"
								needsThousandSeparator
								type="text"
							/>
						</Grid>
					</Grid>
					<Grid xs={12} sm={12}>
						<Button
							type="submit"
							disabled={!formState.isValid}
							fullWidth
							color="secondary"
							variant="outlined"
							size="small"
						>
							جستجو
						</Button>
					</Grid>
				</Grid>
			</form>
		</React.Fragment>
	);
};

export default ReceiptSearch;
